export default __webpack_public_path__ + "static/media/inventory-bag.97746de5.png";